import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  fetchMe,
  createMasterPassword,
  resetMasterPassword,
} from '../../actions';

class GlobalLock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      masterPassword: '',
      masterPasswordConf: '',
      oldMasterPassword: '',
      otp: '',
      masterCreated: false,
    };
    this.createPass = this.createPass.bind(this);
    this.resetPass = this.resetPass.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  createPass(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    const { otp, masterPassword, masterPasswordConf } = this.state;

    const mismatchMaster = (masterPassword && masterPasswordConf) && (masterPassword !== masterPasswordConf);

    if (mismatchMaster) {
      return;
    }

    const data = {
      otp,
      masterPassword,
    };
    dispatch(createMasterPassword(data)).then((res) => {
      if (res.type === 'CREATE_MASTER_PASSWORD_SUCCESS') {
        this.setState({ masterCreated: true });
      }
      dispatch(fetchMe());
    });
  }

  resetPass(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    const { otp, masterPassword, oldMasterPassword, masterPasswordConf } = this.state;

    const mismatchMaster = (masterPassword && masterPasswordConf) && (masterPassword !== masterPasswordConf);

    if (mismatchMaster) {
      return;
    }

    const data = {
      otp,
      oldPassword: oldMasterPassword,
      newPassword: masterPassword,
    };
    dispatch(resetMasterPassword(data)).then((res) => {
      if (res.type === 'RESET_MASTER_PASSWORD_SUCCESS') {
        this.props.toggleModal(null);
      }
      dispatch(fetchMe());
    });
  }

  render() {
    const { user, resetCode } = this.props;
    const { masterPassword, oldMasterPassword, otp, masterCreated, masterPasswordConf } = this.state;

    let masterEnabled;
    if (user && user.me && user.me.flags && user.me.flags.masterPasswordSet) {
      masterEnabled = user.me.flags.masterPasswordSet;
    }

    let passMin;
    let passCaps;
    let passNum;
    let passSpec;

    if (masterPassword.length >= 8) {
      passMin = true;
    }
    if (/[A-Z]/.test(masterPassword)) {
      passCaps = true;
    }
    if (/[0-9]/.test(masterPassword)) {
      passNum = true;
    }
    if (/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~]/.test(masterPassword)) {
      passSpec = true;
    }

    const mismatchMaster = (masterPassword && masterPasswordConf) && (masterPassword !== masterPasswordConf);

    const passRating = [passMin, passCaps, passNum, passSpec].filter(Boolean).length;

    const enableReady = passMin && passCaps && passNum && passSpec && masterPassword && otp && !mismatchMaster;

    if (masterCreated) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-title">
            Master Password
          </div>
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Master Password Created</div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <p>
                Your Master Password has been successfully created.
              </p>
              <p>
                You can now enable your Global Lock.
              </p>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="vlt-button" type="button" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Close
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (masterEnabled) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-title">
            Master Password
          </div>
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Reset Your Master Password</div>
              <div className="modal-subheading">
                Please enter your old and new master password, as well as your 2FA token.
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <form onSubmit={this.resetPass} id="form1">
                <div className="input-wrapper">
                  <input className="modal-input" type="password" id="oldMasterPassword" name="oldMasterPassword" placeholder="Old Master Password" value={oldMasterPassword} onChange={this.handleChange} autoComplete="off" />
                </div>
                <div className="input-wrapper">
                  <input className="modal-input" type="password" id="masterPassword" name="masterPassword" placeholder="New Master Password" value={masterPassword} onChange={this.handleChange} autoComplete="off" />
                </div>
                <div className="input-wrapper">
                  <input
                    className={mismatchMaster ? "modal-input e-warn" : "modal-input"}
                    type="password" id="masterPasswordConf" name="masterPasswordConf" placeholder="Confirm New Master Password" value={masterPasswordConf} onChange={this.handleChange} autoComplete="off" />
                    {mismatchMaster ? (
                      <p className="e-warn">New master password fields must match</p>
                    ) : null}
                </div>
                <div className="p-scale-wrapper">
                  <div className={'p-scale rate-' + passRating}>
                    <div className="p-s-level" />
                    <div className="p-s-level" />
                    <div className="p-s-level" />
                    <div className="p-s-level" />
                    <div className="p-s-level" />
                  </div>
                  <div className="p-scale-text">
                    <span>Weak</span>
                    <span>Strong</span>
                  </div>
                  <div>
                    <div className={passMin ? 'p-s-req true' : 'p-s-req'}>
                      <div className="p-s-check" />
                      <div className="p-s-check-label">at least 8 characters</div>
                    </div>
                    <div className={passCaps ? 'p-s-req true' : 'p-s-req'}>
                      <div className="p-s-check" />
                      <div className="p-s-check-label">at least 1 capital letter</div>
                    </div>
                    <div className={passNum ? 'p-s-req true' : 'p-s-req'}>
                      <div className="p-s-check" />
                      <div className="p-s-check-label">at least 1 number</div>
                    </div>
                    <div className={passSpec ? 'p-s-req true' : 'p-s-req'}>
                      <div className="p-s-check" />
                      <div className="p-s-check-label">at least 1 special character (!@#$&*)</div>
                    </div>
                  </div>
                </div>
                <input className="modal-input" type="text" id="otp" name="otp" placeholder="2FA Token" onChange={this.handleChange} value={otp} autoComplete="off" />
              </form>
            </div>

            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Cancel
                </span>
              </button>
              <button className="vlt-button" type="submit" form="form1" disabled={!enableReady}>
                <span>
                  Reset
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="cell small-12 medium-12 large-12">
        <div className="modal-title">
          Master Password
        </div>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-heading">Create Your Master Password</div>
            <div className="modal-subheading">
              To enable the global lock, please create your master password.
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <form onSubmit={this.createPass} id="form2">
              <div className="input-wrapper">
                <input className="modal-input" type="password" id="masterPassword" name="masterPassword" placeholder="Master Password" value={masterPassword} onChange={this.handleChange} autoComplete="off" />
              </div>
              <div className="input-wrapper">
                <input
                  className={mismatchMaster ? "modal-input e-warn" : "modal-input"}
                  type="password" id="masterPasswordConf" name="masterPasswordConf" placeholder="Confirm New Master Password" value={masterPasswordConf} onChange={this.handleChange} autoComplete="off" />
                  {mismatchMaster ? (
                    <p className="e-warn">New master password fields must match</p>
                  ) : null}
              </div>
              <div className="p-scale-wrapper">
                <div className={'p-scale rate-' + passRating}>
                  <div className="p-s-level" />
                  <div className="p-s-level" />
                  <div className="p-s-level" />
                  <div className="p-s-level" />
                  <div className="p-s-level" />
                </div>
                <div className="p-scale-text">
                  <span>Weak</span>
                  <span>Strong</span>
                </div>
                <div>
                  <div className={passMin ? 'p-s-req true' : 'p-s-req'}>
                    <div className="p-s-check" />
                    <div className="p-s-check-label">at least 8 characters</div>
                  </div>
                  <div className={passCaps ? 'p-s-req true' : 'p-s-req'}>
                    <div className="p-s-check" />
                    <div className="p-s-check-label">at least 1 capital letter</div>
                  </div>
                  <div className={passNum ? 'p-s-req true' : 'p-s-req'}>
                    <div className="p-s-check" />
                    <div className="p-s-check-label">at least 1 number</div>
                  </div>
                  <div className={passSpec ? 'p-s-req true' : 'p-s-req'}>
                    <div className="p-s-check" />
                    <div className="p-s-check-label">at least 1 special character (!@#$&*)</div>
                  </div>
                </div>
              </div>
              <input className="modal-input" type="text" id="otp" name="otp" placeholder="2FA Token" onChange={this.handleChange} value={otp} autoComplete="off" />
            </form>
          </div>

          <div className="cell small-12 medium-12 large-12 modal-actions">
            <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
              <span>
                Cancel
              </span>
            </button>
            <button className="vlt-button" type="submit" form="form2" disabled={!enableReady}>
              <span>
                Create
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(GlobalLock);
